import React from 'react'
import moment from 'moment'

import {
    to12Hr
} from '../../../helpers/moment'

const PreferredShifts = ({ notification }) => {
    return (
        <div className="container">
            <div className="py-4 text-muted text-center" style={{ fontSize: '0.8rem' }}>{moment(notification.createdAt).fromNow()}, {to12Hr(moment(notification.createdAt))}</div>
            <h5>{notification.title}</h5>
            {/* <div>
                You were marked as absent for your shift, on Saturday, 31 March 2019, Shift 3 (4:30pm - 9:00pm).
            </div> */}
        </div>
    )
}

export default PreferredShifts